import { Component } from '@angular/core';

@Component({
  selector: 'page-impressum',
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.scss'
})
export class ImpressumComponent {

}
